import { urls } from 'Constants/Urls'
import { axiosDS } from '@pp/axios'
import { SimpleResponse } from 'Types/simpleResponse'

export const feedbackModalApi = {
	createOne: async (data: FormData) => {
		const res = await axiosDS().post<SimpleResponse>(urls.modal.feedback, data)
		return res.data
	},
}
